import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationServiceService} from '../service/authentication-service.service';

@Component({
  selector: 'app-authentication-view',
  templateUrl: './authentication-view.component.html',
  styleUrls: ['./authentication-view.component.css']
})
export class AuthenticationViewComponent implements OnInit {
  public authentications: any = [];
  public noOfAuthentications: any;
  public loading = true;

  itemsPerPage = 10;
  currentPage = 1;
  regExp = '';
  constructor(private authenticationService: AuthenticationServiceService, private router: Router) { }

  ngOnInit() {
    this.getAllAuthentications();
  }

  pageChanged(event) {
    this.currentPage = event;
    this.getAllAuthentications();
    console.log(event);
  }
  public getAllAuthentications() {
    this.loading = true;
    this.authenticationService.getAllAuthentications(this.currentPage - 1, this.itemsPerPage, this.regExp)
        .subscribe(data => {
          const response: any = data.json();
          this.authentications = response.authentications;
          this.noOfAuthentications = response.numberOfAuthentications;
          console.log(response.authentications);

          this.loading = false;
          // TODO - Uncomment below code when useing actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

  search() {
    console.log('' + this.regExp);
    this.getAllAuthentications();
  }


  deleteKey(macAddress) {
    this.authenticationService.removeAuthenticationByMac(macAddress)
        .subscribe(data => {
          if (data.status === 200) {
          this.getAllAuthentications();
          }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }
}
